export default "__VITE_ASSET__Cuk8r$8Q__"